import { variationPlacements } from '@popperjs/core';
import React, { Component } from 'react';
import weekDays from './weekOpenDaysOptions';

class StandAloneWeekOpenDays extends Component {
    constructor(props) {
        super(props);

        this.state = {
            WeekOpenDaysInfo: [],
            LanguageBasedLabel: [],
            PageSlug: '',
            language:'',

        };
    }

    componentDidMount() {
        const { search } = window.location;
        const params = new URLSearchParams(search);
        const requestPage = params.get('page');

        const app = document.getElementById('appStandaloneHeader');
        const { language } = app.dataset;

        let selectedLang = language;
        const message = document.getElementById('langBasedMessage').getAttribute('value');
        const convertedMessage = JSON.parse(message);

        // console.log('convertedMessage', convertedMessage);
        this.setState({language:language,  LanguageBasedLabel: convertedMessage }, () => {
            // const app = document.getElementById('app');
            // const { language } = app.dataset;

            let app = document.getElementById('app');
            let language = '';
            if (app != '' && app != null && app != undefined) {
                language = app.dataset.language;
            } else {
                app = document.getElementById('appStandaloneHeader');
                language = app.dataset.language;
            }

            const showDepartmentHourArray = ['cheap-flights', 
            // 'hotel-deals',
            'fit', 'car-rental-deals', 'cruise-deals', 
            // 'travelgenie',
             'sunquest',
            //   'add-ons', 
            'exotik-journeys',
            "We've got your Back"];



            if (showDepartmentHourArray.includes(requestPage)) {
                var page = requestPage;
            }else if(requestPage == "hotel-deals" || requestPage == "travelgenie" || requestPage == "add-ons" ){
                var page = 'fit';
            }else if(requestPage == "flights-promotion" ){
                var page = 'cheap-flights'
            }else if(requestPage == "cars-promotion" ){
                var page = 'car-rental-deals'
            }else {
                var page = 'fit';
            }

            // let DepartmentName = '';
            // if( page == 'cheap-flights') {
            //     DepartmentName = this.state.LanguageBasedLabel.Header_Air;
            // } else if( page == 'hotel-deals') {
            //     DepartmentName = this.state.LanguageBasedLabel.Header_Hotels;
            // } else if( page == 'car-rental-deals') {
            //     DepartmentName = this.state.LanguageBasedLabel.Header_Cars;
            // } else if( page == 'cruise-deals') {
            //     DepartmentName = this.state.LanguageBasedLabel.Header_Cruises;
            // } else if( page == 'sunquest') {
            //     DepartmentName = this.state.LanguageBasedLabel.Header_Sunquest;
            // } else if( page == 'add-ons') {
            //     DepartmentName = this.state.LanguageBasedLabel.Header_Add_ons;
            // } else if( page == 'exotik-journeys') {
            //     DepartmentName = this.state.LanguageBasedLabel.Header_Exotik_Journeys;
            // } else {
            //     DepartmentName = this.state.LanguageBasedLabel.Header_TravelGenie;
            // }

            this.setState({ PageSlug: page }, () => {
                this.getDepartmentData(selectedLang, this.state.PageSlug);
            });
        });
    }

    getDepartmentData(language, PageSlug) {
        const orgElement = document.getElementById('organizationId');
        let organizationId = '';

        if (orgElement != 'undefined' && orgElement != null) {
            organizationId = document.getElementById('organizationId').value;
        }

        let baseUrl = '';
        if (document.getElementById('baseUrl') != 'undefined' && document.getElementById('baseUrl') != null) {
            baseUrl = document.getElementById('baseUrl').value;
        }

        const xhr = new XMLHttpRequest();
        xhr.open('GET', `${baseUrl}/api/front/getDepartmentHours?lang=${language}&page=${PageSlug}&organizationId=${organizationId}`);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                const data = JSON.parse(xhr.response);
                // console.log('data', data);
                this.setState({ WeekOpenDaysInfo: data });
            } else {
                reject(`status: ${xhr.status}, statusText: ${xhr.statusText}`);
            }
        };
        xhr.onerror = () => {
            reject(`status: ${xhr.status}, statusText: ${xhr.statusText}`);
        };
        xhr.send();
    }

    updateDepartment(e) {
        let app = document.getElementById('app');
        let language = '';
        if (app != '' && app != null && app != undefined) {
            language = app.dataset.language;
        } else {
            app = document.getElementById('appStandaloneHeader');
            language = app.dataset.language;
        }

        this.setState({ PageSlug: e.target.value }, () => {
            this.getDepartmentData(language, this.state.PageSlug);
        });
    }

    render() {
        const { WeekOpenDaysInfo, language} = this.state;
        // console.log('standalone->', this.state,WeekOpenDaysInfo);
        const DepartmentOptions = [
            // { value: 'travelgenie', label: this.state.LanguageBasedLabel.Header_TravelGenie },
            { value: 'cheap-flights', label: this.state.LanguageBasedLabel.Header_Air },
            { value: 'fit', label: this.state.LanguageBasedLabel.Header_Fit },
            // { value: 'hotel-deals', label: this.state.LanguageBasedLabel.Header_Hotels },
            { value: 'car-rental-deals', label: this.state.LanguageBasedLabel.Header_Cars },
            { value: 'cruise-deals', label: this.state.LanguageBasedLabel.Header_Cruises },
            { value: 'sunquest', label: this.state.LanguageBasedLabel.Header_Sunquest },
            // { value: 'add-ons', label: this.state.LanguageBasedLabel.Header_Add_ons },
            { value: 'exotik-journeys', label: this.state.LanguageBasedLabel.Header_Exotik_Journeys },
            { value: 'we-got-your-back', label: this.state.LanguageBasedLabel.Header_We_Got_Your_Back}

        ];

        return (
            <>

                <div className="">
                    <div className="bs-d-flex bs-align-items-center">
                        {this.state.LanguageBasedLabel.Header_Department}:<span className="bs-font-weight-bold bs-mr-2">
                            {/* {this.state.DepartmentName} */}
                            <div className="bs-element-container bs-input-chevron-down bs-input-chevron-down-gray">
                                <select name="DepartmentName" value={this.state.PageSlug} className="bs-form-control bs-mb-0 bs-bg-none bs-border-0 bs-font-size-sm bs-py-0 bs-h-auto bs-pr-3 bs-font-weight-bold bs-pl-1" onChange={(e) => this.updateDepartment(e)}>
                                    {DepartmentOptions.map((items, index) => (
                                        <option value={items.value} key={index}>{items.label}</option>
                                    ))}

                                </select>
                            </div>
                                                                          </span>
                    </div>
                </div>
                <div className="bs-mr-2">|</div>

                <div className={(Object.keys(WeekOpenDaysInfo).length) > 0 ? 'bs-dropdown bs-position-relative bs-font-size-sm bs-input-chevron-down bs-pr-3' : 'bs-d-none'}>
                    <div className="bs-dropdown-toggle bs-d-flex bs-align-items-center bs-text-nowrap">
                        <span className={WeekOpenDaysInfo.isClose == false ? 'bs-green-text bs-font-weight-bold' : 'bs-red-text bs-font-weight-bold'}>{WeekOpenDaysInfo.isClose == false ? this.state.LanguageBasedLabel.Department_Open : this.state.LanguageBasedLabel.Department_Closed} </span>
                        &nbsp;<span> {WeekOpenDaysInfo.isClose == false ? `${this.state.LanguageBasedLabel.Department_Closes} ${WeekOpenDaysInfo.CloseTime}` : ''} </span>
                        
                    </div>
                    <div className="bs-dropdown-menu bs-border-0 bs-bg-white bs-rounded bs-box-shadow bs-w-100 bs-p-2 bs-position-absolute bs-font-size-sm bs-w-auto" aria-labelledby="dropdownMenuButton">
                        <ul className="bs-list-unstyled bs-pb-0 bs-mb-0">

                            {(WeekOpenDaysInfo != null && (Object.keys(WeekOpenDaysInfo).length) > 0)

                                ? WeekOpenDaysInfo.WeekInfo.map((item, index) => (
                                    <li className="bs-mb-2" key={index}>
                                        <span className={item.AllDayStatus == false ? 'bs-green-text' : 'bs-red-text'}>
                                            {item.AllDayStatus == false ? this.state.LanguageBasedLabel.Department_Open : this.state.LanguageBasedLabel.Department_Closed}
                                        </span>&nbsp;
                                        <span>{language == 'fr' ? item.AllDayFR : item.AllDay}  </span>

                                        {item.AllDayStatus == false
                                            ? <span>{item.OpenTime} - {item.CloseTime}</span>
                                            : null}
                                    </li>
                                )) : null}
                            <li className="mb-2">
                                <span>{this.state.LanguageBasedLabel.Department_Note}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </>

        );
    }
}

export default StandAloneWeekOpenDays;
